import React, { useEffect } from 'react'

import AppHeader from './Header';
import AppNavigation from './Navigation';
import Loader from '../../components/loader';
import { useAuthContext } from '../../context/auth';
import { usePartnerContext } from '../../context/partner';
import MobileBottomNav from '../../components/mobile-bottom-nav';

type Props = {
    children: React.ReactNode;
};

export default function AppLayout({ children }: Props) {

    const [path, setPath] = React.useState<string | undefined>(undefined);
    const { loading, student, guarded } = useAuthContext();
    const { colors } = usePartnerContext();

    useEffect(() => {
        setPath(window?.location?.pathname);
    }, [window.location.pathname]);

    const isAuthPage = path?.includes("/auth");
    const redirectingToAuth = !loading && !student;

    if (isAuthPage || !guarded) {
        return <>{children}</>
    }

    if (loading || !path || redirectingToAuth) {
        return <div id={"AppLayoutLoader"} className={"min-h-[dvh] flex items-center justify-center"}>
            <Loader />
            <div style={{
                display: process.env.GATSBY_DEV_TOOLS_ENBALED === "true" ? "block" : "none",
            }}>
                {children}
            </div>
        </div >
    };

    return (
        <div
            className={"flex flex-col"}
            style={{
                minHeight: '100vh',
                backgroundColor: colors.backgroundGray,
                color: colors.textColor
            }}>
            <AppHeader />
            <div className={"md:flex md:flex-1"}>
                <AppNavigation />
                <main className={"max-w-full flex-1 pb-[80px] lg:pb-5"}>
                    {children}
                </main>
            </div>
            <MobileBottomNav />
        </div>
    )
}

